import { render, staticRenderFns } from "./WorkPatternGlobal.vue?vue&type=template&id=23c46857&scoped=true&"
import script from "./WorkPatternGlobal.vue?vue&type=script&lang=js&"
export * from "./WorkPatternGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c46857",
  null
  
)

export default component.exports